import React from "react";
import { Button, Form, Modal } from "antd";

function OtpSetup() {
    const handleBackToLogin = () => {
        window.location.replace("/");
    };

    return (
        <div className='layer_wrap_new'>
            <div className='layer_wrap_login'>
                <div style={{
                    position: 'relative',
                    paddingLeft: '380px',
                    paddingTop: '132px',
                    width: '795px',
                    height: '500px',
                    left: "5px",
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textAlign: 'center'
                }}>
                    <h2 style={{marginBottom: '30px'}}>OTP 설정이 필요합니다</h2>
                    <div style={{marginBottom: '20px', fontSize: '16px'}}>
                        <p>회사 정책에 따라 OTP 인증이 필수입니다.</p>
                        <p>Google Authenticator 설정 후 로그인하세요.</p>
                    </div>

                    <div style={{marginBottom: '30px'}}>
                        <p style={{fontSize: '14px', color: '#666'}}>
                            OTP 설정 방법:
                        </p>
                        <ol style={{textAlign: 'left', fontSize: '14px', color: '#666'}}>
                            <li>Google Authenticator 앱을 설치하세요</li>
                            <li>시스템 관리자에게 OTP 설정을 요청하세요</li>
                            <li>설정 완료 후 다시 로그인하세요</li>
                        </ol>
                    </div>

                    <Button
                        type="primary"
                        onClick={handleBackToLogin}
                        style={{
                            width: '200px',
                            height: '40px',
                            fontSize: '16px',
                            fontWeight: 'bold'
                        }}
                    >
                        로그인 페이지로 돌아가기
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default OtpSetup;